
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
props: {
matchInfo: Object
},
components: {
Flexbox,
FlexboxItem
},
mounted(){
this.reload();
},
methods: {
viewMatch(){
this.$router.push({
path: 'match_info', query: {
matchId: this.matchInfo.id,
homeTeamId: this.matchInfo.homeTeamId,
visitTeamId: this.matchInfo.vistingTeamId
}
});
},
getRoundName (roundType, roundNum, roundTitle) {
var roundName = "--";

if(roundType=='cup_1'){
roundName = "决赛"
}
else if(roundType=='cup_2'){
roundName = "半决赛"
}
else if(roundType=='cup_4'){
roundName = "1/4决赛"
}
else if(roundType=='cup_8'){
roundName = "1/8决赛"
}
else if(roundType=='cup_16'){
roundName = "1/16决赛"
}
else if(roundType=='cup_32'){
roundName = "1/32决赛"
}
else if(roundType=='cup_64'){
roundName = "1/64决赛"
}
else if(roundType=='cup_128'){
roundName = "1/128决赛"
}
else if(roundType=='cup_team'||roundType=='league'){
roundName = "第"+roundNum+"轮"
}
else if(roundType== 'customized_rank_round'){
roundName = roundTitle
} else {
var arr = roundType.split("_")
roundName = +arr[3]+"-"+arr[2]+"名排位赛"
}
return roundName;
},
reload(){
this.objInfo = this.matchInfo;
this.title = this.genTitle();
this.score = this.genScore();
},
genTitle(){
var group = "";
if(this.matchInfo && this.matchInfo.cupGroupName) {
group =  this.matchInfo.cupGroupName + "组";
}
var number = "";

if(this.matchInfo && this.matchInfo.round) {
number = this.getRoundName(this.matchInfo.round.type,this.matchInfo.round.number,this.matchInfo.round.title);
}

return group + (number!=""?" "+number:"");
},
genScore() {
return "VS"
}
},
data () {
return {
title:"",
score:"",
objInfo:{},
}
},
watch: {
matchInfo(curVal, oldVal){
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/round_report_matchSimpleUnstart.vue